import React from "react";
import GeneralUsers from "./UserDetails/GeneralUsers";

export default function UserDetails({ profile }) {
  return <GeneralUsers profile={profile} />;
}
